import Button from 'components/formElements/Button'
import icons from 'assets/icons'
import {useNavigate} from 'react-router'
import DefaultSelect from 'components/formElements/DefaultSelect'
import {criticalLevel, themeColors} from 'utils/Constants'
import {useState, useEffect} from 'react'
import useToast from 'hooks/useToast'
import {useRequest} from 'hooks/useRequest'
import {useParams} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'
import {setTask} from 'redux/features/taskDetail/taskDetailSlice'
import moment from 'moment'
import Spinner from 'components/loader/Spinner'
const TaskDetailTop = () => {
	const navigate = useNavigate()
	const { taskId } = useParams()
	const dispathch = useDispatch()
	const { task } = useSelector((state) => state.taskDetail)
	const [getTaskDetail,taskDetailLoading] = useRequest()
	const [getStatuses] = useRequest()
	const [updateTask] = useRequest()
	const [taskStatuses,setTaskStatuses] = useState([])
	const { showToast } = useToast()
	const handleStatuChange = (e) => {
		updateTask('/Ticket/UpdateTickets',{
			method:'PUT',
			data:{...task,[e.name]:e.value}
		}).then(res => {
			if (res.data.ok) {
				showToast('İşlem başarılı', 'success')
				dispathch(setTask({...task,[e.name]:e.value}))
			}
		})
		
	}

  useEffect(() => {
	getTaskDetail('/Ticket/GetTicketById',{
		method:'GET',
		params:{
			id:taskId
		}
	}).then(res => {
		if (res.data.ok) {
			dispathch(setTask(res.data.result))
		}
	})
	getStatuses('/TicketStatus/GetAllTicketStatus',{method:'GET'}).then(res => {
		if (res.data.ok) {
			setTaskStatuses(res.data.result.map(p => ({label:p.name,value:p.id, name:'ticketStatusId'})))	
		}
	})
  },[])
  const criticalLevelClass = criticalLevel(task)?.className
  const taskCreatedDiff = moment(new Date()).diff(moment(task?.createdAt),'days')
  if (!task && !taskDetailLoading) {
	return <div>Veri Bulunamadı</div>
  }
  if (taskDetailLoading) {
		return (
			<div className='card pb-5 mb-5'>
				<div className='row text-center'>
					<div className='col-md-12'>
						<Spinner size={3} />
					</div>
				</div>
			</div>
		)
	}
	return (
		<div className='card pb-5 mb-5'>
			<div>
				<div className='row gap-5'>
					<h1 className='heading-1 text-bold'>#{task.code} - {task.title}</h1>
					<Button title='Düzenle' handleClick={() => navigate('edit')} className='btn' icon={<icons.edit />} />
				</div>
				<div className='row'>
					<p className='text-muted text-sm'>{task.createdBy} tarafından {moment(task.createdAt).format('LLL')} tarihinde oluşturuldu.</p>
				</div>
				<div className="pl-0 w-fit-content">
				<DefaultSelect
					placeholder='Görev Durumu'
					borderless
					menuMinWidth= '8rem'
					handleChange={handleStatuChange}
					value={taskStatuses.find(p => p.value == task.ticketStatusId)}
					textColor={task.ticketStatusId == 2 ? themeColors.success : task.ticketStatusId == 3 ? themeColors.warning : themeColors.defaultFont }
					selectOptions={taskStatuses}
				/>
				</div>
			</div>
			<hr className='divider' />
			<div className='row'>
				<div className='col-md-9 mb-5'>
					<div className='task-detail-text' dangerouslySetInnerHTML={{ __html: task.description }} />
				</div>
				<div className='col-md-3 d-flex flex-column gap-3'>
					<div className={`card bg-${criticalLevelClass}`}>
						<div className='div'>
							<div className={`text-${criticalLevelClass}`}>{task.ticketPriority?.name}</div>
							<div className='text-default'>{task.ticketStatus?.name}</div>
							<div className='text-muted'>{taskCreatedDiff > 0  ? `${taskCreatedDiff} gün önce iletildi` : 'Bugün İletildi'}</div>
						</div>
					</div>
					{
						task.ticketDocuments?.length > 0 && <div className='card bg-success'>
						{
							task.ticketDocuments.map(doc => (
								<div key={doc.id} className='text-success bg-success'>
									<icons.attach size={13} /> <a download={doc.fileName} href={`data:${doc.documentType};base64,${doc.data}`} className='bg-success'>{doc.fileName}</a>
								</div>
							))
						}
					</div>
					}
				</div>
			</div>
		</div>
	)
}

export default TaskDetailTop
